'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./ColorToolIcon.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var ColorToolIcon = function ColorToolIcon(props) {
    var color = props.color,
        isActive = props.isActive,
        selectedType = props.selectedType;


    var classes = {
        active: isActive,
        'no-color': !color || !color.hex
    };

    var iconStyle = color ? { background: color.hex } : {};

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('ColorToolIcon', selectedType, classes) },
        _react2.default.createElement('div', { className: 'color-icon', style: iconStyle })
    );
};

// Styles


ColorToolIcon.propTypes = {
    color: _propTypes2.default.object,
    isActive: _propTypes2.default.bool,
    selectedType: _propTypes2.default.string
};

exports.default = ColorToolIcon;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/colorTools/ColorToolIcon.js
// module id = 2232
// module chunks = 0